export default __webpack_public_path__ + "de004a7088d67677ec47cb94c358deee.png";